interface RarityBadgeProps {
  rarity: string;
}

const rarityStyles: Record<string, string> = {
  Common: 'bg-muted text-muted-foreground',
  Uncommon: 'bg-secondary text-secondary-foreground',
  Rare: 'bg-ink-sapphire/20 text-ink-sapphire',
  'Super Rare': 'bg-ink-amethyst/20 text-ink-amethyst',
  Legendary: 'bg-primary/20 text-primary',
  Enchanted: 'bg-primary/30 text-primary',
  Special: 'bg-ink-ruby/20 text-ink-ruby',
};

export function RarityBadge({ rarity }: RarityBadgeProps) {
  return (
    <span className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-medium font-body ${rarityStyles[rarity] || rarityStyles.Common}`}>
      {rarity}
    </span>
  );
}
